import { authService } from "@/services/auth.service";
import { authModule } from "@/store/modules/auth.module";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";

export default async function beforeEachRouteEnter(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {

  if (!authModule.isLoggedIn && to.name != 'Login') {
    const user = await authService.restoreAuth()
    if (user != null) {
      authModule.onAuth(user)
      return next()
    } else {
      return next({ name: 'Login'})
    }
  }
  next()
}